import React from 'react';
import { render } from 'react-dom';
import { App } from '~/App';
import "~/assets/style/index.less";
import '~/assets/style/index.scss';


render(<App />, document.getElementById('root'))
